
























import {Component, Mixins} from 'vue-property-decorator';
import DialogMixin from '@/mixins/DialogMixins';
import router from '@/router';

@Component({
  inheritAttrs: false,
})
export default class CancelChangesDialog extends Mixins(DialogMixin) {
  routeName!: string;

  onOk() {
    router.push(`${this.routeName}`);
  }

  open(name: string) {
    this.dialog = true;
    this.routeName = name;
  }
}
